
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"32","fill":"#0CCE6B","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M8 8h48v48H8z"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M26 40.34l-6.94-6.94c-.78-.78-2.04-.78-2.82 0-.78.78-.78 2.04 0 2.82l8.36 8.36c.78.78 2.04.78 2.82 0l21.16-21.16c.78-.78.78-2.04 0-2.82-.78-.78-2.04-.78-2.82 0L26 40.34z"}})])])
          )
        }
      }
    